<template>
  <b-modal
    id="flat-modal"
    cancel-variant="outline-secondary"
    :ok-title="isEdit ? $t('generals.save') : $t('generals.create')"
    :cancel-title="$t('generals.cancel')"
    centered
    no-close-on-backdrop
    :title="isEdit ? $t('generals.save') : $t('objects.create_room')"
    size="xl"
    @hidden="form_obj = def_form_obj"
    @ok="saveClick"
  >
    <validation-observer ref="flatValidations">
      <app-collapse accordion>
        <validated-form
          :def_form_obj="form_obj"
          :form_fields="getFormFields"
        />
        <b-row class="mb-1 align-items-end">
          <custom-validated-input
            v-if="form_obj.current_status === 4"
            v-model="form_obj.occupied_by"
            component-name="v-select"
            :field-label="$t('objects.who_is_employed')"
            cols-size="12"
            :field-props="{
              options: GET_OCCUPIED_BY_LIST,
              getOptionLabel: (option) => option.fullname[$i18n.locale],
              reduce: (option) => option.id,
            }"
          />
          <b-col cols="9">
            <label for="">{{ $t("objects.type_of_living_space") }}</label>
            <v-select
              v-model="selected_living_area_field"
              :options="GET_FLAT_LIVING_AREA_TYPES"
              :get-option-label="(option) => option.title[$i18n.locale]"
            />
          </b-col>
          <b-col cols="2">
            <label for="">{{ $t("objects.area") }}</label>
            <b-form-input
              v-model="selected_living_area_value"
              type="number"
              @keyup.enter="addAreaValue(1)"
            />
          </b-col>
          <b-col
            class=""
            cols="1"
          >
            <b-button
              variant="success"
              class="px-1"
              @click="addAreaValue(1)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
            <!-- <custom-validated-input
                v-model="selected_living_area_value"
                field-label="Площадь м²"
                cols-size="3"
                @keyup.enter="addAreaValue"
              /> -->
          </b-col>
        </b-row>
        <b-row class="align-items-end">
          <template v-for="(area_field, index) in area">
            <custom-validated-input
              :key="index"
              v-model="area_field.value"
              :field-label="index + 1 + '. ' + area_field.title[$i18n.locale]"
              cols-size="3"
              :field-props="{
                type: 'number',
              }"
            />
            <b-col
              :key="index + 'btn'"
              class="mb-1"
              cols="1"
            >
              <b-button
                class="px-1"
                variant="danger"
                @click="removeAreaField(index, 1)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
          </template>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="4">
            <label for="">{{ $t("objects.total_usable_area") }}</label>
            <b-form-input
              v-model="form_obj.total_area"
              type="number"
              :formatter="(val) => parseFloat(val).toFixed(2)"
            />
            <!-- :formatter="val => val.toFixed(2)" -->
          </b-col>
          <b-col cols="4">
            <label for="">{{ $t("objects.total_usable_area_to_bti") }}</label>
            <b-form-input
              v-model="form_obj.total_bti_area"
              type="number"
            />
          </b-col>
          <b-col cols="4">
            <label for="">{{ $t("objects.difference") }}</label>
            <b-form-input
              type="number"
              :value="getDifference"
            />
          </b-col>
        </b-row>
        <b-row class="mb-1 align-items-end">
          <b-col cols="9">
            <label for="">{{ $t("objects.integral_part") }}</label>
            <v-select
              v-model="selected_nonliving_area_field"
              :options="GET_FLAT_NONLIVING_AREA_TYPES"
              :get-option-label="(option) => option.title[$i18n.locale]"
            />
          </b-col>
          <b-col cols="2">
            <label for="">{{ $t("objects.area") }}</label>
            <b-form-input
              v-model="selected_nonliving_area_value"
              type="number"
              @keyup.enter="addAreaValue(2)"
            />
          </b-col>
          <b-col cols="1">
            <!-- class="d-flex justify-content-end" -->
            <b-button
              variant="success"
              class="px-1"
              @click="addAreaValue(2)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
            <!-- <custom-validated-input
                v-model="selected_living_area_value"
                field-label="Площадь м²"
                cols-size="3"
                @keyup.enter="addAreaValue"
              /> -->
          </b-col>
        </b-row>
        <b-row class="align-items-end">
          <template v-for="(area_field, index) in nonliving_area">
            <custom-validated-input
              :key="index + area.length + 1"
              v-model="area_field.value"
              :field-label="
                index + area.length + 1 + '. ' + area_field.title[$i18n.locale]
              "
              cols-size="3"
            />
            <b-col
              :key="'btn' + (index + area.length + 1)"
              class="mb-1"
              cols="1"
            >
              <b-button
                class="px-1"
                variant="danger"
                @click="removeAreaField(index, 2)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
          </template>
        </b-row>
        <b-row>
          <custom-validated-input
            v-model="form_obj.surcharge"
            :field-label="$t('objects.additional_price')"
            cols-size="3"
          />
        </b-row>
        <app-collapse-item :title="$t('objects.basic_properties')">
          <b-card>
            <validated-form
              :def_form_obj="form_obj"
              :form_fields="getMainPropertiesFields"
            />
          </b-card>
        </app-collapse-item>

        <app-collapse-item :title="$t('objects.additional_fields')">
          <b-card>
            <validated-form
              :def_form_obj="form_obj"
              :form_fields="getAdditionalFields"
            />
          </b-card>
        </app-collapse-item>
      </app-collapse>
    </validation-observer>
  </b-modal>
</template>

<script>
/* eslint-disable */
import {
  BModal, BCard, BRow, BButton, BCol, BFormInput,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import {
  ValidationObserver,
  // ValidationProvider
} from 'vee-validate'
import { required } from '@validations'
import validatedForm from '@/components/validatedForm.vue'
import CustomValidatedInput from '@/components/CustomValidatedInput.vue'
import flatStatuses from '@/mixins/flat_statuses'

export default {
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    vSelect,
    AppCollapse,
    AppCollapseItem,
    validatedForm,
    ValidationObserver,
    // ValidationProvider,
    CustomValidatedInput,
  },
  mixins: [flatStatuses],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    def_form_obj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    def_area: {
      type: Array,
      required: false,
      default() {
        return {}
      },
    },
    def_nonliving_area: {
      type: Array,
      required: false,
      default() {
        return {}
      },
    },
    def_area_fields: {
      type: Array,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      form_obj: {},
      required,
      selected_living_area_value: '',
      selected_living_area_field: null,
      selected_nonliving_area_field: null,
      selected_nonliving_area_value: '',
      area_fields: {},
      area: [],
      calculations: {
        selected_payment_interest: null,
        discount: 0,
        installment: 0,
      },
      nonliving_area: [],
      status_options: [
        {
          title: this.$t('objects.freely'),
          id: 1,
        },
        {
          title: this.$t('objects.booked'),
          id: 2,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('flats', ['GET_FLAT_TYPES', 'GET_FLAT_CHARACTERISTIC']),
    ...mapGetters('knowledgeBase', [
      'GET_FLAT_STATUSES',
      'GET_OUTPUT_WINDOWS',
      'GET_FLAT_DECORATIONS',
      'GET_FLAT_LIVING_AREA_TYPES',
      'GET_FLAT_NONLIVING_AREA_TYPES',
      'GET_OCCUPIED_BY_LIST',
      'GET_PAYMENT_INTERESTS',
    ]),
    filteredStatuses() {
      if (this.form_obj.not_allowed_to_book) {
        return this.GET_FLAT_STATUSES.filter(status => status.id !== 2)
      }
      return this.GET_FLAT_STATUSES
    },
    getFormFields() {
      return [
        {
          component_name: 'v-select',
          col_size: 3,
          obj_name: 'flat_type',
          label: `${this.$t('objects.type_of_premises')}:`,
          placeholder: this.$t('objects.type_of_premises'),
          props: {
            options: this.GET_FLAT_TYPES,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.value,
          },
        },
        {
          obj_name: 'flat_number',
          col_size: 3,
          validation_rules: 'required',
          label: `${this.$t('objects.number_of_premises')}:`,
          placeholder: this.$t('objects.number_of_premises'),
        },
        {
          obj_name: 'rooms_count',
          col_size: 3,
          validation_rules: 'required',
          label: `${this.$t('objects.numbers_room')}:`,
          placeholder: this.$t('objects.numbers_room'),
        },
        {
          component_name: 'v-select',
          col_size: 3,
          obj_name: 'current_status',
          label: `${this.$t('objects.status')}:`,
          validation_rules: 'required',
          placeholder: this.$t('objects.status'),
          props: {
            options: this.filteredStatuses,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
          },
        },
        {
          component_name: 'b-form-checkbox',
          col_size: 3,
          obj_name: 'is_free_planning',
          content_text: this.$t('objects.free_layout'),
          props: {
            switch: true,
            inline: true,
          },
        },
        {
          component_name: 'b-form-checkbox',
          col_size: 3,
          obj_name: 'is_euro_planning',
          content_text: this.$t('objects.builders_layout'),
          props: {
            switch: true,
            inline: true,
          },
        },
        {
          component_name: 'b-form-checkbox',
          col_size: 3,
          obj_name: 'is_studio',
          content_text: this.$t('objects.studio'),
          props: {
            switch: true,
            inline: true,
          },
        },
        {
          component_name: 'b-form-checkbox',
          content_text: this.$t('objects.cant_book'),
          col_size: 3,
          obj_name: 'not_allowed_to_book',
          props: {
            switch: true,
            inline: true,
          },
        },
        {
          component_name: 'b-form-checkbox',
          content_text: this.$t('objects.duplex'),
          col_size: 3,
          obj_name: 'is_duplex',
          props: {
            switch: true,
            inline: true,
          },
        },
      ]
    },
    getMainPropertiesFields() {
      return [
        {
          component_name: 'b-form-textarea',
          label: `${this.$t('objects.description')}(uz):`,
          col_size: 4,
          placeholder: this.$t('objects.description'),
          obj_name: 'description_uz',
        },
        {
          component_name: 'b-form-textarea',
          label: `${this.$t('objects.description')}(ru):`,
          col_size: 4,
          placeholder: this.$t('objects.description'),
          obj_name: 'description_ru',
        },
        {
          component_name: 'b-form-textarea',
          label: `${this.$t('objects.description')}(en):`,
          col_size: 4,
          placeholder: this.$t('objects.description'),
          obj_name: 'description_en',
        },
        {
          obj_name: 'area_number',
          label: this.$t('objects.position'),
          component_name: 'v-select',
          col_size: 6,
          props: {
            options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          },
        },
        {
          component_name: 'v-select',
          obj_name: 'output_window',
          col_size: 6,
          label: this.$t('objects.where_window_to'),
          props: {
            options: this.GET_OUTPUT_WINDOWS,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
          },
        },
        {
          component_name: 'v-select',
          obj_name: 'decoration',
          col_size: 6,
          label: `${this.$t('objects.finishing')}:`,
          props: {
            options: this.GET_FLAT_DECORATIONS,
            getOptionLabel: option => option.title[this.$i18n.locale],
            reduce: option => option.id,
          },
        },
      ]
    },
    getDifference() {
      return this.form_obj.total_bti_area - this.form_obj.total_area
    },
    getAdditionalFields() {
      return [
        {
          label: `${this.$t('objects.room_for_bti')}:`,
          obj_name: 'number_bti',
          col_size: 6,
        },
        {
          label: `${this.$t('objects.area_without_balcony')}:`,
          col_size: 6,
          obj_name: 'area_without_balcony',
        },
        {
          label: `${this.$t('objects.specifications')}:`,
          component_name: 'v-select',
          col_size: 12,
          obj_name: 'characteristics',
          props: {
            multiple: true,
            options: this.GET_FLAT_CHARACTERISTIC,
            reduce: option => option.id,
            getOptionLabel: option => option.title[this.$i18n.locale],
          },
        },
      ]
    },
  },
  watch: {
    def_form_obj() {
      this.form_obj = this.def_form_obj
    },
    def_area() {
      this.area = this.def_area
    },
    def_area_fields() {
      this.area_fields = this.def_area_fields
    },
    area: {
      handler(val) {
        this.form_obj.total_area = 0
        // Object.values(val).forEach(el => {
        //   this.form_obj.total_area += Number(el)
        // })
        val.forEach(el => {
          this.form_obj.total_area += Number(el.value)
        })
      },
      deep: true,
    },
    'form_obj.total_area': function (newVal) {
      if (newVal) {
        this.form_obj.total_area = newVal.toFixed(2)
      }
    },
  },
  mounted() {
    this.FETCH_FLAT_STATUSES()
    this.FETCH_OUTPUT_WINDOWS()
    this.FETCH_FLAT_DECORATIONS()
    this.FETCH_FLAT_LIVING_AREA_TYPES()
    this.FETCH_FLAT_NONLIVING_AREA_TYPES()
    this.FETCH_FLAT_CHARACTERISTIC()
    this.FETCH_OCCUPIED_BY_LIST()
    this.FETCH_PAYMENT_INTERESTS()
    this.form_obj = this.def_form_obj
    this.area = this.def_area
    this.nonliving_area = this.def_nonliving_area
    this.area_fields = this.def_area_fields
  },
  methods: {
    ...mapActions('flats', [
      'ADD_FLAT',
      'EDIT_FLAT',
      'FETCH_FLAT_CHARACTERISTIC',
    ]),
    ...mapActions('knowledgeBase', [
      'FETCH_FLAT_STATUSES',
      'FETCH_OUTPUT_WINDOWS',
      'FETCH_FLAT_DECORATIONS',
      'FETCH_FLAT_LIVING_AREA_TYPES',
      'FETCH_FLAT_NONLIVING_AREA_TYPES',
      'FETCH_OCCUPIED_BY_LIST',
      'FETCH_PAYMENT_INTERESTS',
    ]),
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.flatValidations.validate().then(success => {
        if (success) {
          const {
            description_uz, description_ru, description_en, ...rest
          } = this.form_obj
          this.form_obj = {
            description: {
              uz: description_uz,
              ru: description_ru,
              en: description_en,
            },
            ...rest,
          }
          this.form_obj.area = this.area.concat(this.nonliving_area)
          if (this.isEdit) {
            // if (this.form_obj.current_status === this.flat_statuses.booked) this.$delete(this.form_obj, 'current_status')
            this.EDIT_FLAT(this.form_obj)
              .then(() => {
                this.$_successToast(this.$t('generals.changed'))
                this.$emit('addSuccess')
              })
              .catch(() => {
                this.$_errorToast(this.$t('generals.error'))
              })
          } else {
            this.ADD_FLAT(this.form_obj)
              .then(() => {
                this.$_successToast(this.$t('generals.added'))
                this.$emit('addSuccess')
              })
              .catch(() => {
                this.$_errorToast(this.$t('generals.error'))
              })
          }
        }
      })
    },
    addAreaValue(type) {
      // area: [
      //   {
      //     id: 1,
      //     title: {
      //       uz: 'Uy kinoteatri',
      //       ru: 'Домашный кинотеатр',
      //     },
      //     value: '15'
      //   },
      //   {
      //     id: 1,
      //     title: {
      //       uz: 'Uy kinoteatri',
      //       ru: 'Домашный кинотеатр',
      //     },
      //     value: '10'
      //   },
      //   {
      //     id: 3,
      //     title: {
      //       uz: 'Yotoqxona',
      //       ru: 'Спалная',
      //     },
      //     value: '15'
      //   }
      // ]

      // old-variant
      // this.$set(this.area, this.selected_living_area_field.id, this.selected_living_area_value)
      // this.$set(this.area_fields, this.selected_living_area_field.id, this.selected_living_area_field)

      // new-variant
      if (type === 1) {
        // this.$set(this.selected_living_area_field, 'value', this.selected_living_area_value)
        this.area.push({
          title: this.selected_living_area_field.title,
          value: Number(this.selected_living_area_value).toFixed(2),
          room_title: this.selected_living_area_field.id,
        })
      }
      if (type === 2) {
        // this.$set(this.selected_nonliving_area_field, 'value', this.selected_nonliving_area_value)
        this.nonliving_area.push({
          title: this.selected_nonliving_area_field.title,
          value: Number(this.selected_nonliving_area_value).toFixed(2),
          room_title: this.selected_nonliving_area_field.id,
        })
        // this.nonliving_area.push(this.selected_nonliving_area_field)
      }
      // this.selected_living_area_field = null
      // this.selected_living_area_value = ''
    },
    removeAreaField(index, type) {
      // this.$delete(this.area, id)
      // this.$delete(this.area_fields, id)
      if (type === 1) {
        // this.$set(this.area, index)
        this.area.splice(index, 1)
      }
      if (type === 2) this.nonliving_area.splice(index, 1)

      // delete this.area_fields[id]
      // delete this.area[id]
    },
    calculatePayment() {
      this.calculations.price_per_kv = (1 - this.calculations.discount / 100) * this.form_obj.price_per_kv
    },
  },
}
</script>

<style></style>
